const moduleName = 'datalayer',
	selectors = {
		base: `.js-${moduleName}`
	}

export class DataLayer {
	constructor(baseElement) {
		this.element = baseElement;
		
		this.bindEvents();

	}

	addDataLayer() {
		try {
			const data = JSON.parse(this.element.dataset.datalayer.replaceAll('\'', '"'));
			dataLayer.push(data);
		} catch (err) {
			return false;
		}
    }

	onEventHandler(ev) {
		ev.preventDefault();
		ev.stopImmediatePropagation();

		this.addDataLayer();

		window.location = ev.currentTarget?.href;
	}

	bindEvents() {
		this.element?.addEventListener('click', (ev) => {
			this.onEventHandler(ev);
			return false;
		});
	}

}

function initDataLayer() {

	document.querySelectorAll(selectors.base).forEach((element) => {
		new DataLayer(element);
	});
}

initDataLayer();